import styled from "styled-components";
import type { ReactNode } from "react";
import type React from "react";

type Props = {
  widgetId: string;
  children: ReactNode;
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ModalContentContainer: React.FC<Props> = (props: Props) => {
  const { children } = props;

  return <Container>{children}</Container>;
};
